<template>
  <section id="formlayout">
    <div class="demo">
      <form class="needs-validation" novalidate="novalidate">
        <div class="row">
          <div class="col-lg-6 col-xxl-4">
            <div class="form-group">
              <label for="validationCustom01">First name</label>
              <input type="text" class="form-control" id="validationCustom01" placeholder="First name" value="Mark" required="required">
              <div class="valid-feedback">
                Looks good!
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xxl-4">
            <div class="form-group">
              <label for="validationCustom02">Last name</label>
              <input type="text" class="form-control" id="validationCustom02" placeholder="Last name" value="Otto" required="required">
              <div class="valid-feedback">
                Looks good!
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xxl-4">
            <div class="form-group">
              <label for="validationCustom03">Mobile</label>
              <input type="tel" class="form-control" id="validationCustom03" required="required">
            </div>
          </div>
          <div class="col-lg-6 col-xxl-4">
            <div class="form-group">
              <label for="validationCustomUsername">Username
              </label>
              <a href="#" class="link-alt" data-container="body" data-toggle="popover" data-placement="right" data-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." aria-label="help">
                <i class="gel-icon-help-o"></i>
              </a>
              <input type="text" class="form-control" id="validationCustomUsername" placeholder="Username" aria-describedby="inputGroupPrepend" required="required">
              <div class="invalid-feedback">
                <i class="gel-icon-error" aria-hidden="true"></i>
                Please choose a username.
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xxl-4">
            <div class="form-group">
              <label for="validationCustom03">City</label>
              <input type="text" class="form-control" id="validationCustom03" placeholder="City" required="required">
              <div class="invalid-feedback">
                <i class="gel-icon-error" aria-hidden="true"></i>
                Please provide a valid city.
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xxl-4">
            <div class="form-group">
              <label for="validationCustom04">State</label>
              <input type="text" class="form-control" id="validationCustom04" placeholder="State" required="required">
              <div class="invalid-feedback">
                <i class="gel-icon-error" aria-hidden="true"></i>
                Please provide a valid state.
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xxl-4">
            <div class="form-group">
              <label for="validationCustom05">Zip</label>
              <input type="text" class="form-control" id="validationCustom05" placeholder="Zip" required="required">
              <div class="invalid-feedback">
                <i class="gel-icon-error" aria-hidden="true"></i>
                Please provide a valid zip.
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xxl-4">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Languages</label>
              <select class="form-control" id="exampleFormControlSelect1">
                <option value="en">English</option>
                <option value="en-us">English (US)</option>
                <option value="es">Español (Spanish)</option>
                <option value="de">Deutsch (German)</option>
                <option value="tr">Türkçe (Turkish)</option>
                <option value="zh-s">简体中文 (Chinese, Simplified)</option>
                <option value="ja">日本語 (Japanese)</option>
                <option value="nl">Nederlands (Dutch)</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="exampleFormControlTextarea1">Introduction</label>
          <a href="#" class="link-alt" data-container="body" data-toggle="popover" data-placement="right" data-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." aria-label="help">
            <i class="gel-icon-help-o"></i>
          </a>
          <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
        </div>
        <div class="form-group">
          <div class="checkbox checkbox-primary">
            <input class="form-check-input" id="checkbox2" type="checkbox" required="required"/>
            <label class="form-check-label" for="checkbox2">
              Agree to terms and conditions
            </label>
            <div class="invalid-feedback">
              <i class="gel-icon-error" aria-hidden="true"></i>
              You must agree before submitting.
            </div>
          </div>
        </div>
        <button class="btn btn-primary" type="submit">Submit</button>
      </form>
    </div>
    <div class="demo">
      <h5>Form section model</h5>
      <section class="form-section" role="group" aria-labelledby="section-title-x" tabindex="0" id="sectionID">
        <!-- section header -->
        <div class="form-section-header">
            <span class="form-section-title">
              <span id="section-title-x" class="h3" aria-hidden="true">Section Heading</span>
            </span>
        </div>
        <!-- section body -->
        <div class="form-section-body">
            <!-- Form controls goes here-->
            ...
        </div>
      </section>
       <!-- form section model -->
      <section class="form-section" role="group" aria-labelledby="section-title-x"
        tabindex="1" id="sectionID">
        <div class="form-section-header">
            <span class="form-section-title">
            <span id="section-title-x" class="h3" aria-hidden="true">Section
            Heading</span>
            <a href="#_" class="info-icon"><i
              class="gel-icon-help-o gel-icon-lg"></i></a>
            </span>
            <span class="form-section-switch">
              <span>Required </span>
              <div class="toggle toggle-primary d-inline-block">
                  <label><input type="checkbox" checked="checked"><span>&nbsp;</span></label>
              </div>
            </span>
        </div>
        <div class="form-section-body">
            ...
        </div>
      </section>
      <section class="form-section" role="group" aria-labelledby="section-title-x" tabindex="0" id="sectionID">
        <!-- section header -->
        <div class="form-section-header">
            <span class="form-section-title">
              <span id="section-title-x" class="h3" aria-hidden="true">Section Heading</span>
              <!-- trigger the popover-->
              <a href="#_" class="info-icon">
                <i class="gel-icon-help-o gel-icon-lg"></i>
              </a>
            </span>
            <span class="form-section-switch">
              <!-- toggle button goes here-->

            </span>
        </div>
        <!-- section body -->
        <div class="form-section-body">
            <!-- Form controls goes here-->
            ...
        </div>
      </section>

    </div>
    <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import BSN from 'bootstrap.native/dist/bootstrap-native-v4'
import mdfile from "@/docs/forms/form.md";
export default {
  name: "formlayout",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.forms.formlayout.name);
    this.$emit("update-tagline", this.$root.yamlData.forms.formlayout.description);
  },
  mounted: function () {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    Array.prototype.filter.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      }, false);
    });

    const infoPopovers = document.querySelectorAll('[data-toggle="popover"]')
    infoPopovers.forEach(infoPopover => {
      new BSN.Popover(infoPopover)
    })
  },
  data() {
    return {
      mdfile
    };
  }

};

</script>
